/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { InviteUserFromUserRequestUserAccountRole } from './invite-user-from-user-request-user-account-role';

/**
 * 
 * @export
 * @interface InviteUserFromUserRequest
 */
export interface InviteUserFromUserRequest {
    /**
     * Name of the user to invite
     * @type {string}
     * @memberof InviteUserFromUserRequest
     */
    'name'?: string | null;
    /**
     * Email address of the user to invite
     * @type {string}
     * @memberof InviteUserFromUserRequest
     */
    'email'?: string | null;
    /**
     * Account role privilege for the invited user
     * @type {string}
     * @memberof InviteUserFromUserRequest
     */
    'userPrivilege'?: InviteUserFromUserRequestUserPrivilegeEnum;
    /**
     * 
     * @type {InviteUserFromUserRequestUserAccountRole}
     * @memberof InviteUserFromUserRequest
     */
    'userAccountRole'?: InviteUserFromUserRequestUserAccountRole | null;
}

export const InviteUserFromUserRequestUserPrivilegeEnum = {
    generalUser: 'GENERAL_USER',
    organizationAdmin: 'ORGANIZATION_ADMIN',
    viewer: 'VIEWER',
    bookkeeper: 'BOOKKEEPER'
} as const;

export type InviteUserFromUserRequestUserPrivilegeEnum = typeof InviteUserFromUserRequestUserPrivilegeEnum[keyof typeof InviteUserFromUserRequestUserPrivilegeEnum];


